import _ from 'lodash'
import Vue from "vue";

import {
    BUILDING_SET_SELECTED,
    BUILDINGS_SET,
} from '../muations'


const state = {
    all: {},
    selectedBuilding: 0,
}

// getters
const getters = {

}

// actions
const actions = {
    // getAllDevs ({ commit }) {
    //     shop.getProducts(devs => {
    //         commit('setDevs', devs)
    //     })
    // }
}

// mutations
const mutations = {
    [BUILDINGS_SET] (state, buildings) {
        _.forEach(buildings, b => {
            Vue.set(state.all, b.id, b)
            _.forEach(b, (bPropVal, bPropKey) => {
                Vue.set(state.all[b.id], bPropKey, bPropVal)
            })
        })
    },

    [BUILDING_SET_SELECTED](state, buildingId){
        state.selectedBuilding = state.all[buildingId]
    },
}

export default {
    // namespaced: true,
    state,
    getters,
    actions,
    mutations
}
